import React, { useContext } from "react"
import tw from "twin.macro"
import { TactVideoSectionProps } from "./Tact.d"
import { Image } from "../../atoms/Image"
import { parseDisclaimerBlocks } from "../../../helpers"
import ExternalVideo from "../../molecules/VideoSection/ExternalVideo"
import { toggleDisclaimersModal } from "../../../contexts/Disclaimers/actions"
import { DisclaimersContext } from "../../../contexts/Disclaimers"

/**
 *
 * @author Cody
 * @summary
 *
 *
 */

const VideoSection: React.FC<TactVideoSectionProps> = ({
  videoSectionVideo,
  videoSectionHeading,
  videoSectionBackground,
}) => {
  const [state, dispatch] = useContext(DisclaimersContext)
  return (
    <>
      <section
        aria-label="Toyota Apprenticeship Career Training Video Section"
        css={[
          tw`flex relative h-[210px] w-full bg-gray-800`,
          tw`md:(items-center  h-[500px])`,
          tw`lg:(h-[682px])`,
        ]}
      >
        {videoSectionBackground && (
          <Image
            imageData={videoSectionBackground}
            width={1440}
            height={1008}
            css={[
              tw`hidden w-full h-auto object-cover`,
              "z-index: 0;",
              tw`lg:(h-[680px] flex object-cover)`,
            ]}
          />
        )}

        <div
          css={[
            tw`flex flex-col justify-center mx-auto w-full h-full absolute xl:(px-60 pt-20 pb-10)`,
          ]}
        >
          {videoSectionHeading && (
            <h3 css={[tw`text-base font-semibold my-5 text-white text-center`]}>
              {parseDisclaimerBlocks(videoSectionHeading, selection =>
                dispatch(toggleDisclaimersModal(selection)),
              )}
            </h3>
          )}
          <ExternalVideo
            videoSectionHeading=""
            videoSectionVideo={videoSectionVideo}
            videoCss={[tw`h-full bg-gray-800 w-auto xl:(px-32 h-full )`]}
          />
        </div>
      </section>
    </>
  )
}

export default VideoSection
